// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"90aefd86","498":"2c65c4e8","703":"3d75b398"}[chunkId] + ".chunk.js";
};